import { useContext } from 'react';
import { MembershipContext } from '../contexts/MembershipContext';

export function useMembership() {
  const context = useContext(MembershipContext);
  if (context === undefined) {
    throw new Error('useMembership must be used within a MembershipProvider');
  }
  return context;
}
